import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  OccConfig,
  ConfigModule,
  CmsConfig,
  I18nConfig,
  I18nModule,
  provideConfig,
  provideDefaultConfig,
  provideDefaultConfigFactory,
  UrlModule,
  PageMetaResolver
} from '@spartacus/core';
import {
  SplitViewModule,
  TableModule,
  IconModule,
  PaginationModule,
  KeyboardFocusModule,
  PopoverModule,
  LayoutConfig,
  CardModule,
} from '@spartacus/storefront';
import {
  DisableInfoModule,
  MessageModule,
  ToggleStatusModule,
} from '@spartacus/organization/administration/components';
import {
  branchesRoutingConfig,
  branchesTableConfigFactory,
  branchesCmsConfig,
} from './uig-branches.config';
import {
  UigBranchesAdapter,
  UIG_BRANCHES_NORMALIZER,
} from '../store/uig-branches.adapter';
import { UigBranchesEffects } from '../store/uig-branches.effects';
import {
  uigBranchesFeatureKey,
  uigBranchesReducer,
} from '../store/uig-branches.reducer';
import { UigBranchesListNormalizer } from '../converters/uig-branches-list-normalizer';
import { UigListModule } from './uig-list/uig-list.module';
import { UigBranchFormModule } from './uig-branch-form/uig-branch-form.module';
import { UigBranchDetailsComponent } from './uig-branch-details/uig-branch-details.component';
import { UigCellComponent } from './uig-cell/uig-cell.component';
import { UigCheckboxComponent } from './uig-checkbox/uig-checkbox.component';
import { OrganizationPageMetaResolver } from '@spartacus/organization/administration/core';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SplitViewModule,
    TableModule,
    IconModule,
    UrlModule,
    I18nModule,
    PaginationModule,
    NgSelectModule,
    FormsModule,
    MessageModule,
    KeyboardFocusModule,
    PopoverModule,
    UigListModule,
    CardModule,
    ToggleStatusModule,
    DisableInfoModule,
    UigBranchFormModule,
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            uigBranches: '/branches',
            uigBranchDetails: '/branches/details',
            uigStoreLocatorFeatureGroups: '/branches/storeLocatorFeatureGroups',
            uigBranchDelete: '/branches/delete',
            uigBranchCreateOrUpdate: '/branches/create',
            uigStoreFeatureKeys: '/branches/storeFeatureKeys',
          },
        },
      },
    } as OccConfig),
    StoreModule.forFeature(uigBranchesFeatureKey, uigBranchesReducer),
    EffectsModule.forFeature([UigBranchesEffects]),
  ],
  providers: [
    provideDefaultConfig(branchesRoutingConfig),
    provideDefaultConfig(branchesCmsConfig),
    provideDefaultConfigFactory(branchesTableConfigFactory),
    {
      provide: UigBranchesAdapter,
      useClass: UigBranchesAdapter,
    },
    {
      provide: UIG_BRANCHES_NORMALIZER,
      useExisting: UigBranchesListNormalizer,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: OrganizationPageMetaResolver,
      multi: true,
    },
    provideConfig(<I18nConfig>{
      i18n: {
        chunks: {
          uigBranches: [
            'branches',
            'branchDetails',
            'branchesEdit',
            'branchesCreate',
            'breadcrumbs'
          ],
        },
      },
    }),
    provideDefaultConfig(<CmsConfig | LayoutConfig>{
      cmsComponents: {
        CellComponent: {
          component: UigCellComponent,
        },
      },
    }),
  ],
  declarations: [
    UigBranchDetailsComponent,
    UigCellComponent,
    UigCheckboxComponent,
  ],
})
export class UigBranchesComponentsModule {}
